<script setup lang="ts">
import { type IValidationResult } from "@/interfaces";
import SVG from "@/stories/displays/SVG/SVG.vue";
import InputValidationError from "@/stories/form/InputValidationError/InputValidationError.vue";

interface Props {
  forId: string;
  name: string;
  label?: string;
  description?: string;
  isRequired?: boolean;
  inputKey?: string;
  tooltip?: string;
  disabled?: boolean;
  fullHeight?: boolean;
  validation?: IValidationResult | null;
  errorMessageKey?: string;
  hideValidationError?: boolean;
}

withDefaults(defineProps<Props>(), {
  hideValidationError: false,
});

defineEmits([]);
</script>

<template>
  <div class="w-full">
    <div
      class="flex flex-col"
      :class="{ 'h-full': fullHeight }"
      :data-id="`input-wrapper-${inputKey}`"
    >
      <label
        v-if="label"
        class="flex items-center"
        :class="
          ['mb-2 h200', disabled ? 'text-neutral600' : 'text-neutral1000'].join(
            ' ',
          )
        "
        v-bind:for="forId"
      >
        {{ label }} {{ isRequired ? "*" : "" }}
        <span v-if="tooltip" class="pl-1">
          <SVG
            icon="fas-info-circle"
            height="1.25rem"
            width="1.25rem"
            v-tooltip.bottom="{ content: tooltip, theme: 'borger-default' }"
          />
        </span>
        <span v-if="description" class="pl-1 b200 text-neutral1000">
          ({{ description }})
        </span>
      </label>
      <slot></slot>
      <InputValidationError
        v-if="hideValidationError === false"
        :name="name"
        :validation="validation"
        :error-message-key="errorMessageKey"
      />
    </div>
  </div>
</template>

<style lang="scss"></style>
